export const toDataURL = async (url: string): Promise<string> =>
  fetch(`${url}`, {credentials: "include"})
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            if (typeof reader.result === "string") {
              resolve(reader.result);
            } else {
              reject("Could not read image");
            }
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );

export async function getScaledDimensions(
  dataURL: string,
  maxWidth: number,
  maxHeight: number
): Promise<{ w: number; h: number }> {
  return new Promise((resolve, reject) => {
    // Create a new Image object
    let img = new Image();

    // Handle errors if the image cannot be loaded
    img.onerror = (err) => {
      reject(`Image could not be loaded`);
    };

    // Once the image is loaded, calculate the scaled dimensions
    img.onload = function () {
      console.log("loading");
      // Get the original width and height of the image (in pixels)
      let originalWidth = img.naturalWidth;
      let originalHeight = img.naturalHeight;

      // Assuming a default DPI of 96 (pixels per inch)
      const dpi = 96;

      // Convert image size from pixels to inches
      let originalWidthInches = originalWidth / dpi;
      let originalHeightInches = originalHeight / dpi;

      // Calculate the scale factors for width and height
      let scaleWidth = maxWidth / originalWidthInches;
      let scaleHeight = maxHeight / originalHeightInches;

      // Use the smaller scale factor to maintain aspect ratio
      let scaleFactor = Math.min(scaleWidth, scaleHeight);

      // Calculate the new scaled dimensions (width and height)
      let scaledWidth = originalWidthInches * scaleFactor;
      let scaledHeight = originalHeightInches * scaleFactor;

      console.log({ w: scaledWidth, h: scaledHeight });
      // Return the scaled width and height
      resolve({ w: scaledWidth, h: scaledHeight });
    };

    // Start loading the image
    img.src = dataURL;
  });
}

export async function roundImageCorners(
  dataURL: string,
  width: number,
  height: number,
  radius: number
): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        reject(`Image could not be loaded`);
        return;
      }
      // Set canvas size
      canvas.width = width;
      canvas.height = height;

      // Draw rounded rectangle
      ctx.beginPath();
      ctx.moveTo(radius, 0);
      ctx.lineTo(width - radius, 0);
      ctx.quadraticCurveTo(width, 0, width, radius);
      ctx.lineTo(width, height - radius);
      ctx.quadraticCurveTo(width, height, width - radius, height);
      ctx.lineTo(radius, height);
      ctx.quadraticCurveTo(0, height, 0, height - radius);
      ctx.lineTo(0, radius);
      ctx.quadraticCurveTo(0, 0, radius, 0);
      ctx.closePath();
      ctx.clip(); // Clip the image to the rounded rectangle

      // Draw the image inside the clipped region
      ctx.drawImage(img, 0, 0, width, height);

      // Convert the canvas to a data URL
      resolve(canvas.toDataURL("image/png"));
    };

    img.onerror = (err) => {
      console.error(err);
      reject(`Image could not be loaded`);
    };
    img.src = dataURL;
  });
}
